itsoftApp.createModule("youtubeVideo", function() {
    var module = this;

    var init = function () {
        var playButtons = document.querySelectorAll('.js-video');
        var activePlayer;
        var players = [];
        var initialized = false;
        var playerIndex;
        var queue = {                        
            content: playVideo,
            push: function(fn) {
                this.content = fn;
            },
            pop: function() {
                this.content.call();
                this.content = null;
            }
        }

        function isPlayerReady() {
            return activePlayer && typeof activePlayer.playVideo === 'function';
        }

        function pauseVideo() {
            if (isPlayerReady()) {
                activePlayer.pauseVideo();
            } else {
                queue.push(function() {
                  activePlayer.pauseVideo();
                });
            }
        }

        function playVideo() {
            if (isPlayerReady()) {
                activePlayer.playVideo();
            } else {
                queue.push(function() {
                  activePlayer.playVideo();
                });
            }
        }

        var onPlayerReady = function (event) {
            initialized = true;
            activePlayer = players[+playerIndex];

            if (queue.content) {
                queue.pop();
            }
        }

        window.onYouTubeIframeAPIReady = function () {
            var options = {
                playerVars: {"rel": 0, "enablejsapi": 1, "origin": window.location.origin},
                host: window.location.protocol + "//www.youtube.com"
            }

            for (var i = 0; i < playButtons.length; i++) {
                var playButton = playButtons[i];
                var videoPlaceId = playButton.getAttribute("data-video");
                var videoLink = playButton.getAttribute("href");
                var videoLinkSubstringIndex = videoLink.lastIndexOf("/");
                var videoId = videoLink.substring(videoLinkSubstringIndex + 1, videoLink.length);

                if (i === playButtons.length - 1) {
                    options.events = {
                        "onReady": onPlayerReady
                    }
                }

                options.videoId = videoId;

                players[i] = new YT.Player(videoPlaceId, options);
            }
        }

        var initYoutube = function (playButton) {
            var popupId = playButton.getAttribute("data-popup-selector");
            var popupVideo = document.querySelector(popupId);
            var closeButton = popupVideo.querySelector(".js-close-popup");

            playButton.addEventListener('click', function (evt) {
                evt.preventDefault();
                playerIndex = playButton.getAttribute("data-video-index");

                if (!initialized) {
                    var tag = document.createElement('script');
                    tag.src = window.location.protocol + "//www.youtube.com/iframe_api"; //player_api
                    document.body.appendChild(tag);
                } else {
                    activePlayer = players[+playerIndex];
                    activePlayer.playVideo();
                }
            })

            popupVideo.addEventListener("click", function (evt) {
                if (evt.target.classList.contains("popup")) {
                    pauseVideo();
                }
            });

            closeButton.addEventListener('click', function (evt) {
                activePlayer.pauseVideo();
            });

            var onEscKeyup = function (evt) {
                if (evt.keyCode === 27) {
                    pauseVideo();
                }
            }

            window.addEventListener("keyup", onEscKeyup);
        }

        if (playButtons) {
            for (var i = 0; i < playButtons.length; i++) {
                initYoutube(playButtons[i]);
            }
        }
    }

    module.callback = init;
});
